import React from 'react';
import {
  Award,
  Zap,
  MapPin,
  Users,
  Puzzle,
  Activity,
  GitBranch,
  Layers,
  ShieldCheck,
  Sparkles,
} from 'lucide-react';

/**
 * Scrolling trust bar shown above the main nav on desktop.
 * Reuses `.logo-scroll-track` marquee animation defined in App.css.
 * Content is duplicated once so the loop is seamless.
 */
const items = [
  { icon: MapPin, text: 'UK-based support' },
  { icon: Award, text: 'In business since 1979' },
  { icon: Zap, text: 'CIP4 active members' },
  { icon: Users, text: 'IPIA & Picon members' },
  { icon: Puzzle, text: '24+ pre-built integrations' },
  { icon: Activity, text: 'Real-time machine data' },
  { icon: GitBranch, text: 'JDF workflow specialists' },
  { icon: Layers, text: 'Bespoke MIS for print & packaging' },
  { icon: ShieldCheck, text: 'Owned & run by industry veterans' },
  { icon: Sparkles, text: 'Free demo — no obligation' },
];

const TrustBar = () => {
  const doubled = [...items, ...items];
  return (
    <div
      className="block bg-[#0a0b10] text-white overflow-hidden border-b border-white/5"
      data-testid="navbar-trust-bar"
    >
      <div className="trust-bar-track py-1.5 lg:py-2">
        {doubled.map((item, i) => {
          const Icon = item.icon;
          return (
            <div
              key={`${item.text}-${i}`}
              className="flex items-center gap-2 mx-5 lg:mx-8 whitespace-nowrap text-[10px] lg:text-xs tracking-wide text-white/80"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              <Icon size={12} className="text-[#00BCE4] flex-shrink-0 lg:size-3.5" strokeWidth={2.25} />
              <span>{item.text}</span>
              <span className="ml-5 lg:ml-8 text-white/20" aria-hidden="true">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrustBar;
